// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k1UkXGwRAvPZVn {
  display: flex;
  transition: 0.2s gap ease;
  color: var(--ds-text, #172b4d);
  font-size: 16px;
  text-decoration: none;
  gap: var(--ds-space-050, 4px);
}
.k1UkXGwRAvPZVn:hover {
  gap: var(--ds-space-100, 8px);
  color: var(--ds-text, #172b4d);
}
`, ""]);
// Exports
export var primaryLink = `k1UkXGwRAvPZVn`;
export default ___CSS_LOADER_EXPORT___;
